// import React from 'react';
// import { makeStyles } from '@material-ui/core/styles';
// import Table from '@material-ui/core/Table';
// import TableBody from '@material-ui/core/TableBody';
// import TableCell from '@material-ui/core/TableCell';
// import TableContainer from '@material-ui/core/TableContainer';
// import TableHead from '@material-ui/core/TableHead';
// import Typography from '@material-ui/core/Typography';
// import TableRow from '@material-ui/core/TableRow';
// import TablePagination from '@material-ui/core/TablePagination';
// import { Paper } from "@material-ui/core";
// import { Checkbox } from "@material-ui/core";

// const useStyles = makeStyles(() => ({
//     smallPagination: {
//         "& .MuiTablePagination-caption": {
//             flexShrink: 0,
//             fontSize: "12px",
//         },
//         "& .MuiTablePagination-selectRoot": {
//             fontSize: "12px",
//         },
//         "& .MuiTablePagination-displayedRows": {
//             fontSize: "12px",
//         },
//         "& .MuiTablePagination-actions .MuiIconButton-root": {
//             padding: "4px",
//         },
//         "& .MuiTablePagination-actions svg": {
//             fontSize: "16px",
//         },
//     },
//     tableCell: {
//         padding: '8px',
//         border: '1px solid rgba(233, 235, 245, 1)',
//         fontSize: '12px',
//         fontWeight: '400',
//         fontStyle: 'normal',
//         lineHeight: '17px',
//         color: 'rgba(95, 96, 113, 1)',
//         whiteSpace: 'nowrap',
//         overflow: 'hidden',
//         textOverflow: 'ellipsis',
//         maxWidth: '200px',
//     },
//     tableHeaderCell: {
//         padding: '8px',
//         fontSize: '12px',
//         fontWeight: '500',
//         fontStyle: 'normal',
//         lineHeight: '17px',
//         color: 'rgba(95, 96, 113, 1)',
//         whiteSpace: 'nowrap',
//         overflow: 'hidden',
//         textOverflow: 'ellipsis',
//         maxWidth: 80,
//         border: '1px solid rgba(233, 235, 245, 1)',
//     },
//     cellContent: {
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         gap: '8px',
//     },
//     cellText: {
//         fontSize: '12px',
//         fontWeight: '400',
//         fontStyle: 'normal',
//         lineHeight: '17px',
//         color: 'rgba(95, 96, 113, 1)',
//         whiteSpace: 'nowrap',
//         overflow: 'hidden',
//         textOverflow: 'ellipsis',
//         maxWidth: '200px',
//     },
//     actionIcon: {
//         width: '25px',
//         height: '25px',
//         cursor: 'pointer',
//     },
//     actionCell: {
//         display: 'flex',
//         justifyContent: 'center',
//     },
// }));

// const DataTable = ({
//     // Table configuration
//     headers = [],
//     data = [],

//     // Pagination
//     page = 0,
//     rowsPerPage = 10,
//     totalRecords = 0,
//     onPageChange,
//     onRowsPerPageChange,
//     showPagination = true, 

//     // Selection
//     showCheckbox = false,
//     selectedItems = [],
//     onSelectionChange,
//     onSelectAll,

//     // Styling
//     cellStyle = {},
//     headerStyle = {},

//     // Actions
//     actionColumn = false,
//     onActionClick,
//     actionIcon = null,

//     // Custom renderers
//     customCellRenderer = null,
//     customHeaderRenderer = null,

//     // Additional props
//     ...props
// }) => {
//     const classes = useStyles();

//     // Check if all items are selected
//     const isAllSelected = data.length > 0 && selectedItems.length === data.length;
//     const isIndeterminate = selectedItems.length > 0 && selectedItems.length < data.length;

//     // Handle individual row selection
//     const handleRowSelection = (itemId, isSelected) => {
//         if (onSelectionChange) {
//             onSelectionChange(itemId, isSelected);
//         }
//     };

//     // Handle select all
//     const handleSelectAllChange = (isSelected) => {
//         if (onSelectAll) {
//             onSelectAll(isSelected);
//         }
//     };

//     // Render cell content
//     // const renderCellContent = (row, header, headerIndex) => {
//     //     if (customCellRenderer) {
//     //         return customCellRenderer(row, header, headerIndex);
//     //     }

//     //     const value = header.value;
//     //     let cellData = row[value];

//     //     // Handle nested object values
//     //     if (cellData === undefined || cellData === null) {
//     //         cellData = row[`${value}.value`] || row[`$${value}`]?.value;
//     //     }

//     //     // Handle object values
//     //     if (cellData && typeof cellData === 'object') {
//     //         if (cellData.value !== undefined) {
//     //             cellData = cellData.value;
//     //         } else {
//     //             cellData = JSON.stringify(cellData);
//     //         }
//     //     }

//     //     return (
//     //         <div className={classes.cellContent}>
//     //             <Typography className={classes.cellText}>
//     //                 {cellData || ''}
//     //             </Typography>
//     //             {header.showIcon && (
//     //                 <img
//     //                     src={header.icon || "/media/createStepper/openView.svg"}
//     //                     alt="action"
//     //                     style={{ width: '16px', height: '16px' }}
//     //                 />
//     //             )}
//     //         </div>
//     //     );
//     // };

//     const renderCellContent = (row, header, headerIndex) => {
//         if (customCellRenderer) {
//             return customCellRenderer(row, header, headerIndex);
//         }

//         const value = header.value;
//         let cellData = row[value];

//         // Handle nested object values
//         if (cellData === undefined || cellData === null) {
//             cellData = row[`${value}.value`] || row[`$${value}`]?.value;
//         }

//         // Handle object values
//         if (cellData && typeof cellData === 'object') {
//             if (cellData.value !== undefined) {
//                 cellData = cellData.value;
//             } else {
//                 cellData = JSON.stringify(cellData);
//             }
//         }

//         // Format cell data with pound symbol if isPoundIcon is true
//         const formatCellData = (data) => {
//             if (header.isPoundIcon && data !== null && data !== undefined && data !== '') {
//                 // Format number with commas and add pound symbol
//                 const numericValue = typeof data === 'number' ? data : parseFloat(data);
//                 if (!isNaN(numericValue)) {
//                     return `£${numericValue.toLocaleString('en-GB')}`;
//                 }
//             }
//             return data || '';
//         };

//         return (
//             <div className={classes.cellContent}>
//                 <Typography className={classes.cellText}>
//                     {formatCellData(cellData)}
//                 </Typography>
//                 {header.showIcon && (
//                     <img
//                         src={header.icon || "/media/createStepper/openView.svg"}
//                         alt="action"
//                         style={{ width: '16px', height: '16px' }}
//                     />
//                 )}
//             </div>
//         );
//     };

//     // Render header content
//     const renderHeaderContent = (header, index) => {
//         if (customHeaderRenderer) {
//             return customHeaderRenderer(header, index);
//         }

//         return header.label || header.name || header;
//     };

//     return (
//         <div>
//             <TableContainer component={Paper} style={{ boxShadow: 'none' }}>
//                 <Table style={{ width: '100%', tableLayout: 'fixed', borderCollapse: 'collapse' }} aria-label="data table">
//                     <TableHead style={{ backgroundColor: '#fff', height: '40px' }}>
//                         <TableRow>
//                             {/* Checkbox column */}
//                             {showCheckbox && (
//                                 <TableCell 
//                                     padding="checkbox" 
//                                     className={classes.tableHeaderCell}
//                                     style={{
//                                         borderTopLeftRadius: '8px',
//                                         ...headerStyle
//                                     }}
//                                 >
//                                     <Checkbox
//                                         size="small"
//                                         checked={isAllSelected}
//                                         indeterminate={isIndeterminate}
//                                         onChange={(e) => handleSelectAllChange(e.target.checked)}
//                                     />
//                                 </TableCell>
//                             )}

//                             {/* Data headers */}
//                             {headers.map((header, index) => (
//                                 <TableCell 
//                                     key={index}
//                                     className={classes.tableHeaderCell}
//                                     style={{
//                                         borderTopLeftRadius: showCheckbox ? 0 : (index === 0 ? '8px' : 0),
//                                         borderTopRightRadius: index === headers.length - 1 ? '8px' : 0,
//                                         ...headerStyle
//                                     }}
//                                 >
//                                     {renderHeaderContent(header, index)}
//                                 </TableCell>
//                             ))}

//                             {/* Action column */}
//                             {actionColumn && (
//                                 <TableCell
//                                     className={classes.tableHeaderCell}
//                                     style={{
//                                         width: '50px',
//                                         borderTopRightRadius: '8px',
//                                         ...headerStyle
//                                     }}
//                                 >
//                                     Action
//                                 </TableCell>
//                             )}
//                         </TableRow>
//                     </TableHead>
//                     <TableBody>
//                         {data.map((row, idx) => {
//                             const itemId = row.id || row._id || row.documentId || idx;
//                             const isSelected = selectedItems.includes(itemId);

//                             return (
//                                 <TableRow key={idx}>
//                                     {/* Checkbox column */}
//                                     {showCheckbox && (
//                                         <TableCell 
//                                             padding="checkbox" 
//                                             className={classes.tableCell}
//                                             style={cellStyle}
//                                         >
//                                             <Checkbox
//                                                 size="small"
//                                                 checked={isSelected}
//                                                 onChange={(e) => handleRowSelection(itemId, e.target.checked)}
//                                             />
//                                         </TableCell>
//                                     )}

//                                     {/* Data cells */}
//                                     {headers.map((header, headerIndex) => (
//                                         <TableCell 
//                                             key={headerIndex} 
//                                             className={classes.tableCell}
//                                             style={cellStyle}
//                                         >
//                                             {renderCellContent(row, header, headerIndex)}
//                                         </TableCell>
//                                     ))}

//                                     {/* Action column */}
//                                     {actionColumn && (
//                                         <TableCell 
//                                             className={classes.tableCell}
//                                             style={{ 
//                                                 ...cellStyle,
//                                                 display: 'flex', 
//                                                 justifyContent: 'center' 
//                                             }}
//                                         >
//                                             <img
//                                                 src={actionIcon || "/media/createStepper/deleteContracts.svg"}
//                                                 alt="action"
//                                                 className={classes.actionIcon}
//                                                 onClick={() => onActionClick && onActionClick(row, idx)}
//                                             />
//                                         </TableCell>
//                                     )}
//                                 </TableRow>
//                             );
//                         })}
//                     </TableBody>
//                 </Table>
//             </TableContainer>

//             {/* Pagination */}
//             {showPagination && onPageChange && onRowsPerPageChange && (
//                 <div>
//                     <TablePagination
//                         component="div"
//                         count={totalRecords}
//                         className={classes.smallPagination}
//                         page={page}
//                         onPageChange={onPageChange}
//                         rowsPerPage={rowsPerPage}
//                         onRowsPerPageChange={onRowsPerPageChange}
//                     />
//                 </div>
//             )}
//         </div>
//     );
// };

// export default DataTable;


import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import Typography from '@material-ui/core/Typography';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import { Paper, Checkbox } from "@material-ui/core";
import clsx from 'clsx';
import useStyles from './style';

const DataTable = ({
  // Table configuration
  headers = [],
  data = [],

  // Pagination
  page = 0,
  rowsPerPage = 10,
  totalRecords = 0,
  onPageChange,
  onRowsPerPageChange,
  showPagination = true,

  // Selection
  showCheckbox = false,
  selectedItems = [],
  onSelectionChange,
  onSelectAll,

  // Styling (external overrides stay supported)
  cellStyle = {},
  headerStyle = {},

  // Actions
  actionColumn = false,
  onActionClick,
  actionIcon = null,

  // Custom renderers
  customCellRenderer = null,
  customHeaderRenderer = null,
  uniqueId = null,

  showEditAction = false,
  onEditClick,
  editIcon = "/media/createStepper/editIconNew.svg",

  showDeleteAction = false,
  onDeleteClick,
  deleteIcon = "/media/createStepper/deleteContracts.svg",

  // Additional props
  ...props
}) => {
  const classes = useStyles();

  const tableIdAttr = `table_${uniqueId}`;

  const isAllSelected = data.length > 0 && selectedItems.length === data.length;
  const isIndeterminate = selectedItems.length > 0 && selectedItems.length < data.length;

  const handleRowSelection = (itemId, isSelected) => {
    if (onSelectionChange) onSelectionChange(itemId, isSelected);
  };

  const handleSelectAllChange = (isSelected) => {
    if (onSelectAll) onSelectAll(isSelected);
  };

  const handleActionClick = (row, idx) => {
    console.log('handleActionClick', row, idx, props);
    props.history.push({
       pathname: `/${props?.match?.params?.appid}/page/view/${idx}`
    });
  };

  const renderCellContent = (row, header, headerIndex) => {
    if (customCellRenderer) return customCellRenderer(row, header, headerIndex);

    const valueKey = header.value;
    let cellData = row[valueKey];

    if (cellData === undefined || cellData === null) {
      cellData = row[`${valueKey}.value`] || row[`$${valueKey}`]?.value;
    }

    if (cellData && typeof cellData === 'object') {
      if (cellData.value !== undefined) cellData = cellData.value;
      else cellData = JSON.stringify(cellData);
    }

    const formatCellData = (data) => {
      if (header.isPoundIcon && data !== null && data !== undefined && data !== '') {
        const numericValue = typeof data === 'number' ? data : parseFloat(data);
        if (!isNaN(numericValue)) return `£${numericValue.toLocaleString('en-GB')}`;
      }
      return data || '';
    };

    return (
      <div className={classes.cellContent}>
        <Typography className={classes.cellText}>
          {formatCellData(cellData)}
        </Typography>
        {header.showIcon && (
          <img
            src={header.icon || "/media/createStepper/openView.svg"}
            alt="action"
            className={classes.inlineIcon}
            style={{ cursor: 'pointer' }}
            onClick={() => handleActionClick(row, row?._id || row?.id)}
          />
        )}
      </div>
    );
  };

  const renderHeaderContent = (header, index) => {
    if (customHeaderRenderer) return customHeaderRenderer(header, index);
    return header.label || header.name || header;
  };

  return (
    <div>
      <TableContainer component={Paper} className={classes.tableContainer}>
        <Table className={classes.table} aria-label="data table" id={tableIdAttr}>
          <TableHead className={classes.tableHead}>
            <TableRow>
              {/* Checkbox column */}
              {showCheckbox && (
                <TableCell
                  padding="checkbox"
                  className={clsx(classes.tableHeaderCell, classes.firstHeaderCell)}
                  style={headerStyle}
                >
                  <Checkbox
                    size="small"
                    checked={isAllSelected}
                    indeterminate={isIndeterminate}
                    onChange={(e) => handleSelectAllChange(e.target.checked)}
                  />
                </TableCell>
              )}

              {/* Data headers */}
              {headers.map((header, index) => {
                const isFirst = !showCheckbox && index === 0;
                const isLast = !actionColumn && index === headers.length - 1;
                return (
                  <TableCell
                    key={index}
                    className={clsx(
                      classes.tableHeaderCell,
                      isFirst && classes.firstHeaderCell,
                      isLast && classes.lastHeaderCell
                    )}
                    style={headerStyle}
                  >
                    {renderHeaderContent(header, index)}
                  </TableCell>
                );
              })}

              {/* Action column */}
              {actionColumn && (
                <TableCell
                  className={clsx(classes.tableHeaderCell, classes.lastHeaderCell, classes.actionHeaderCell)}
                  style={headerStyle}
                >
                  Action
                </TableCell>
              )}
            </TableRow>
          </TableHead>

          <TableBody>
            {data.map((row, idx) => {
              const itemId = row.id || row._id || row.documentId || idx;
              const isSelected = selectedItems.includes(itemId);

              return (
                <TableRow key={idx}>
                  {/* Checkbox column */}
                  {showCheckbox && (
                    <TableCell padding="checkbox" className={classes.tableCell} style={cellStyle}>
                      <Checkbox
                        size="small"
                        checked={isSelected}
                        onChange={(e) => handleRowSelection(itemId, e.target.checked)}
                      />
                    </TableCell>
                  )}

                  {/* Data cells */}
                  {headers.map((header, headerIndex) => (
                    <TableCell
                      key={headerIndex}
                      className={classes.tableCell}
                      style={cellStyle}
                    >
                      {renderCellContent(row, header, headerIndex)}
                    </TableCell>
                  ))}

                  {/* Action column */}
                  {/* {actionColumn && (
                    <TableCell className={clsx(classes.tableCell, classes.actionCell)} style={cellStyle}>
                      <img
                        src={actionIcon || "/media/createStepper/deleteContracts.svg"}
                        alt="action"
                        className={classes.actionIcon}
                        onClick={() => onActionClick && onActionClick(row, idx)}
                      />
                    </TableCell>
                  )} */}
                  {(actionColumn || showEditAction || showDeleteAction) && (
                    <TableCell className={clsx(classes.tableCell, classes.actionCell)} style={cellStyle}>
                      <div style={{ display: 'flex', gap: 4 }}>
                        {/* Edit Action */}
                        {showEditAction && (
                          <img
                            src={editIcon}
                            alt="edit"
                            className={classes.actionIcon1}
                            onClick={() => onEditClick && onEditClick(row, idx)}
                            title="Edit"
                          />
                        )}

                        {/* Delete Action */}
                        {showDeleteAction && (
                          <img
                            src={deleteIcon}
                            alt="delete"
                            className={classes.actionIcon}
                            onClick={() => onDeleteClick && onDeleteClick(row, idx)}
                            title="Delete"
                          />
                        )}
                      </div>
                    </TableCell>
                  )}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination */}
      {showPagination && onPageChange && onRowsPerPageChange && (
        <div>
          <TablePagination
            component="div"
            count={totalRecords}
            className={classes.smallPagination}
            page={page}
            onPageChange={onPageChange}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={onRowsPerPageChange}
          />
        </div>
      )}
    </div>
  );
};

export default DataTable;
